// eslint-disable-next-line import/prefer-default-export
const STATUS = {
  COMPLETED: 'completed',
  ACTIVE: 'active',
  FUTURE: 'future',
  DISABLED: 'disabled'
};

export { STATUS as S };
//# sourceMappingURL=constants-d5DDIlHP.js.map
